'use strict';
var form = document.querySelector('.questions__form');
form.addEventListener('submit', function(e) {
    e.preventDefault();
    form.reset();
});
document.addEventListener('DOMContentLoaded', function() {
    var menu = document.querySelector('.page__menu');
    var burger = document.querySelector('.top-bar__burger');
    var closeBtn = document.querySelector('.menu__close');
    var navLinks = document.querySelectorAll('.menu__nav .nav__link');
    var openMenu = function() {
        menu.classList.add('active');
        document.body.classList.add('no-scroll');
    };
    var closeMenu = function() {
        menu.classList.remove('active');
        document.body.classList.remove('no-scroll');
    };
    burger.addEventListener('click', function(e) {
        e.preventDefault();
        openMenu();
    });
    closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        closeMenu();
    });
    navLinks.forEach(function(link) {
        link.addEventListener('click', function() {
            closeMenu();
            navLinks.forEach(function(l) {
                return l.classList.remove('active');
            });
            link.classList.add('active');
        });
    });
});

//# sourceMappingURL=Kickstarter.e3561128.js.map
